import store from "store"
import jwtDecode from "jwt-decode"
import { UserRoles } from "./utils"

/**
 * Authenticated user
 */
export default class Authenticated {

  authority = ''
  username = ''
  email = ''

  super = false
  admin = false
  accountant = false
  approver = false
  underwriter = false
  paymentManager = false

  impersonation = false
  phoneNumber = ''

  constructor() {
    this.init()
  }

  init() {

    const sessionData = store.get("sessionData")
    if (!sessionData || !sessionData.access_token || !(sessionData.authorities instanceof Array)) {
      return
    }

    const accessToken = sessionData.access_token,
    userInfo = store.get('userInfo')

    this.email = jwtDecode(accessToken).user_name

    if (userInfo) {
      this.username = userInfo.name
      this.phoneNumber = userInfo.phoneNumber
    }

    const authority = sessionData.authorities[0]
    this.authority = authority

    switch(authority) {

      case UserRoles.ADMIN:
        this.admin = true
        break

      case UserRoles.SUPER:

        if (userInfo && userInfo.organizationId) {
          this.admin = true
          this.impersonation = true
          this.authority = UserRoles.ADMIN
        }
        else {
          this.super = true
        }
        break

      case UserRoles.ACCOUNTANT:
        this.accountant = true
        break

      case UserRoles.APPROVER:
        this.approver = true
        break

      case UserRoles.UNDERWRITER:
        this.underwriter = true
        break

      case UserRoles.PAYMENT_MANAGER:
        this.paymentManager = true
        break

      default: break
    }
  }

  isSuper = () => this.super

  isImpersonation = () => this.impersonation

  isAdmin = () => this.admin

  isAccountant = () => this.accountant

  isApprover = () => this.approver

  isUnderwriter = () => this.underwriter

  isPaymentManager = () => this.paymentManager

  getUsername = () => this.username

  getEmail = () => this.email

  getAuthority = () => this.authority

  getPhoneNumber = () => this.phoneNumber

  canOpenDevice = () => this.isSuper() || this.isAdmin() || this.isPaymentManager()
}



// WEBPACK FOOTER //
// ./src/lib/Authenticated.js